/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_what_are_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are passkeys?`)
};

const zh_hans1_settings_what_are_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是通行密钥？`)
};

const zh_hant1_settings_what_are_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什麼是通行金鑰？`)
};

const fr_settings_what_are_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que sont les passkeys ?`)
};

const de_settings_what_are_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sind Passkeys?`)
};

const ja_settings_what_are_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーとは？`)
};

const ko_settings_what_are_passkeys = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`패스키란?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_what_are_passkeys = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_what_are_passkeys(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_what_are_passkeys", locale)
	if (locale === "en") return en_settings_what_are_passkeys(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_what_are_passkeys(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_what_are_passkeys(inputs)
	if (locale === "fr") return fr_settings_what_are_passkeys(inputs)
	if (locale === "de") return de_settings_what_are_passkeys(inputs)
	if (locale === "ja") return ja_settings_what_are_passkeys(inputs)
	return ko_settings_what_are_passkeys(inputs)
};